import { render, staticRenderFns } from "./Campos.vue?vue&type=template&id=63bddb62&"
import script from "./Campos.vue?vue&type=script&lang=js&"
export * from "./Campos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports